import { render } from "./HalfIllnessIcon.vue?vue&type=template&id=19042f32"
import script from "./HalfIllnessIcon.vue?vue&type=script&lang=js"
export * from "./HalfIllnessIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__